import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2316852f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dropdown-menu" }
const _hoisted_2 = ["onUpdate:modelValue"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["onUpdate:modelValue"]

import { reactive, ref, watch } from "vue";

interface SelectElement {
  id: string;
  label: string;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    options: null,
    selected: null
  },
  emits: ["updateSelected"],
  setup(__props: any, { emit }) {

const props = __props as {
  options: SelectElement[];
  selected: string[];
}




const isOpen = ref(false);

const selectedMap = reactive({
  ...Object.fromEntries(props.options.map(({ id }) => [id, false])),
  ...Object.fromEntries(props.selected.map((id) => [id, true])),
});

watch(selectedMap, (newVal) => {
  console.log("CHANGE DETECTED");
  const selected = Object.entries(newVal)
    .filter(([, val]) => val)
    .map(([key]) => key);
  selected.sort((a, b) => {
    const aIndex = props.selected.indexOf(a);
    const bIndex = props.selected.indexOf(b);

    const aRealIndex = aIndex === -1 ? Infinity : aIndex;
    const bRealIndex = bIndex === -1 ? Infinity : bIndex;
    return aRealIndex - bRealIndex;
  });
  emit("updateSelected", selected);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.selected, (el) => {
      return (_openBlock(), _createElementBlock("section", { key: el }, [
        _createElementVNode("p", null, _toDisplayString(__props.options.find(({ id }) => id === el)?.label ?? "MissingNo"), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": ($event: any) => ((_unref(selectedMap)[el]) = $event),
          type: "checkbox"
        }, null, 8, _hoisted_2), [
          [_vModelCheckbox, _unref(selectedMap)[el]]
        ])
      ]))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (el) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: el.id
      }, [
        (!__props.selected.includes(el.id))
          ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
              _createElementVNode("p", null, _toDisplayString(el.label), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((_unref(selectedMap)[el.id]) = $event),
                type: "checkbox"
              }, null, 8, _hoisted_4), [
                [_vModelCheckbox, _unref(selectedMap)[el.id]]
              ])
            ]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}
}

})